import React from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import SystemClient from './system/SystemClient';
import Environment from './lib/Environment';
import MessageCourier from './lib/MessageCourier';
import AppInRouterContext from './AppInRouterContext';
import { createTheme, ITheme, ThemeProvider } from '@fluentui/react/lib/Theme';
import { initializeIcons } from '@fluentui/react/lib/Icons';
import UpdateNoticeDialog from './Components/Common/UpdateNoticeDialog';

const environment = new Environment();
const system = SystemClient.start(environment);
const appMessageCourier = new MessageCourier();

initializeIcons();
// initializeFileTypeIcons();
interface IApp {
  newVersionAvailable: boolean;
  onUpdateVersion: () => void;
}

export const darkTheme = createTheme({
  palette: {
    themePrimary: '#ff6c03',
    themeLighterAlt: '#0a0400',
    themeLighter: '#291100',
    themeLight: '#4d2001',
    themeTertiary: '#994102',
    themeSecondary: '#e05f02',
    themeDarkAlt: '#ff7a1c',
    themeDark: '#ff8f3f',
    themeDarker: '#ffad72',
    neutralLighterAlt: '#151823',
    neutralLighter: '#1b1e2c',
    neutralLight: '#262a3b',
    neutralQuaternaryAlt: '#2d3144',
    neutralQuaternary: '#32374b',
    neutralTertiaryAlt: '#4d526a',
    neutralTertiary: '#9e9e9e',
    neutralSecondary: '#f5f7f9',
    neutralSecondaryAlt: '#f5f7f9',
    neutralPrimaryAlt: '#f7f8fa',
    neutralPrimary: '#eff2f6',
    neutralDark: '#fbfcfd',
    black: '#fdfdfe',
    white: '#0f111a',
  },
  semanticColors: {
    inputBorder: '#515050',
    buttonBorder: '#515050',
  },
});

const lightScrollStyles = `
    /* width */
    ::-webkit-scrollbar {
      width: 7px;
      height: 7px;

    }

    /* Fondo */
    ::-webkit-scrollbar-track {
      background: transparent;

    }

    /* Barra */
    ::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 5px
    }

    /* Barra on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  `;

const darkScrollStyles = `
    /* width */
    ::-webkit-scrollbar {
      width: 7px;
      height: 7px;
    }

    /* Fondo */
    ::-webkit-scrollbar-track {
      background: transparent;

    }

    /* Barra */
    ::-webkit-scrollbar-thumb {
      background: #31374a;
      border-radius: 5px
    }

    /* Barra on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  `;

export const lightTheme = createTheme({
  palette: {
    themePrimary: '#0078d4',
    themeLighterAlt: '#eff6fc',
    themeLighter: '#deecf9',
    themeLight: '#c7e0f4',
    themeTertiary: '#71afe5',
    themeSecondary: '#2b88d8',
    themeDarkAlt: '#106ebe',
    themeDark: '#005a9e',
    themeDarker: '#004578',
    neutralLighterAlt: '#faf9f8',
    neutralLighter: '#f3f2f1',
    neutralLight: '#edebe9',
    neutralQuaternaryAlt: '#e1dfdd',
    neutralQuaternary: '#d0d0d0',
    neutralTertiaryAlt: '#c8c6c4',
    neutralTertiary: '#a19f9d',
    neutralSecondary: '#605e5c',
    neutralSecondaryAlt: '#8a8886',
    neutralPrimaryAlt: '#3b3a39',
    neutralPrimary: '#323130',
    neutralDark: '#201f1e',
    black: '#000000',
    white: '#ffffff',
    orange: '#f2be11',
    green: '#28cc25',
    red: '#e31c19',
  },
});

export const isLightTheme = (theme: ITheme) => theme.palette.themePrimary === '#0078d4';

const App = (props: IApp) => {
  const [currentTheme, setCurrentTheme] = React.useState<ITheme | undefined>(undefined);

  const changeTheme = () => {
    if (currentTheme === lightTheme) {
      setCurrentTheme(darkTheme);
    } else {
      setCurrentTheme(lightTheme);
    }
  };

  React.useEffect(() => {
    const temaGuardado = localStorage.getItem('theme');
    if (temaGuardado === 'dark') {
      setCurrentTheme(darkTheme);
    } else {
      setCurrentTheme(lightTheme);
    }
  }, []);

  React.useEffect(() => {
    localStorage.setItem('theme', currentTheme === lightTheme ? 'light' : 'dark');
  }, [currentTheme]);

  return (
    <React.Fragment>
      <ThemeProvider theme={currentTheme} className="transision-theme" style={{ height: '100%' }}>
        <style>{currentTheme && isLightTheme(currentTheme) ? lightScrollStyles : darkScrollStyles}</style>

        <BrowserRouter basename={environment.getLocalBasePath()}>
          {props.newVersionAvailable && (
            <UpdateNoticeDialog
              showDialog={props.newVersionAvailable}
              toggleShowDialog={() => props.onUpdateVersion()}
              onAccept={() => props.onUpdateVersion()}
              onCancel={() => props.onUpdateVersion()}
              hideCancelButton={true}
            ></UpdateNoticeDialog>
          )}

          <AppInRouterContext
            system={system}
            environment={environment}
            courier={appMessageCourier}
            changeTheme={changeTheme}
          />
        </BrowserRouter>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default App;
